import GalleryFilter from './filter'

export default GalleryFilter
